import { extension, bodiedExtension, inlineExtension } from '@atlaskit/adf-schema';
import { createPlugin } from './pm-plugins/main';
import keymapPlugin from './pm-plugins/keymap';
import { createPlugin as createUniqueIdPlugin } from './pm-plugins/unique-id';
import { getToolbarConfig } from './toolbar';
import { getContextPanel } from './context-panel';
var extensionPlugin = function extensionPlugin(_ref) {
  var _api$featureFlags, _api$contextPanel2, _api$contextPanel3;
  var _ref$config = _ref.config,
    options = _ref$config === void 0 ? {} : _ref$config,
    api = _ref.api;
  var featureFlags = (api === null || api === void 0 ? void 0 : (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
  return {
    name: 'extension',
    nodes: function nodes() {
      return [{
        name: 'extension',
        node: extension
      }, {
        name: 'bodiedExtension',
        node: bodiedExtension
      }, {
        name: 'inlineExtension',
        node: inlineExtension
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'extension',
        plugin: function plugin(_ref2) {
          var dispatch = _ref2.dispatch,
            providerFactory = _ref2.providerFactory,
            portalProviderAPI = _ref2.portalProviderAPI,
            eventDispatcher = _ref2.eventDispatcher;
          var extensionHandlers = options.extensionHandlers || {};
          return createPlugin(dispatch, providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
            appearance: options.appearance
          });
        }
      }, {
        name: 'extensionKeymap',
        plugin: function plugin() {
          var _api$contextPanel;
          return keymapPlugin(api === null || api === void 0 ? void 0 : (_api$contextPanel = api.contextPanel) === null || _api$contextPanel === void 0 ? void 0 : _api$contextPanel.actions.applyChange);
        }
      }, {
        name: 'extensionUniqueId',
        plugin: function plugin() {
          return createUniqueIdPlugin();
        }
      }];
    },
    pluginsOptions: {
      floatingToolbar: getToolbarConfig({
        breakoutEnabled: options.breakoutEnabled,
        hoverDecoration: api === null || api === void 0 ? void 0 : api.decorations.actions.hoverDecoration,
        applyChangeToContextPanel: api === null || api === void 0 ? void 0 : (_api$contextPanel2 = api.contextPanel) === null || _api$contextPanel2 === void 0 ? void 0 : _api$contextPanel2.actions.applyChange
      }),
      contextPanel: getContextPanel(options.allowAutoSave, featureFlags, api === null || api === void 0 ? void 0 : (_api$contextPanel3 = api.contextPanel) === null || _api$contextPanel3 === void 0 ? void 0 : _api$contextPanel3.actions.applyChange)
    }
  };
};
export default extensionPlugin;